import { render } from "./arrangeDeleteDialog.vue?vue&type=template&id=4b7cbe41&scoped=true"
import script from "./arrangeDeleteDialog.vue?vue&type=script&lang=js"
export * from "./arrangeDeleteDialog.vue?vue&type=script&lang=js"

import "./arrangeDeleteDialog.vue?vue&type=style&index=0&id=4b7cbe41&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b7cbe41"]])

export default __exports__